// src/firebaseConfig.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyD3-Gnm3xy-LEuGW2EC78XXIuNg_9uBpLk",
  authDomain: "inelf-com.firebaseapp.com",
  projectId: "inelf-com",
  storageBucket: "inelf-com.firebasestorage.app",
  messagingSenderId: "14670345534",
  appId: "1:14670345534:web:585a28a1d44ad3ea82e86f",
  measurementId: "G-9SR26G68X1"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

export { auth };
